import { Navigate } from "react-router-dom";

const TaskAgentRedirect = () => {
  return <Navigate to="/task-agent/inicio" replace />;
};

export default TaskAgentRedirect;
